class MegaMenuTabs {
  constructor(container) {
    this.container = container;
    this.triggers = container.querySelectorAll('.mega-menu-block__link');
    this.rightColumn = container.querySelector('.mega-menu-block__right');
    this.targets = Array.from(this.rightColumn.querySelectorAll('.mega-menu-collection-block')).filter(el => !el.classList.contains('is-default'));
    this.defaultTarget = this.rightColumn.querySelector('.mega-menu-collection-block.is-default');

    this.timer = null;
    this.init();
  }

  init() {
    this.triggers.forEach(trigger => {
        trigger.addEventListener('mouseenter', (e) => this.onTriggerEnter(e));
        trigger.addEventListener('mouseleave', (e) => this.onTriggerLeave(e));
    });

    const allTargets = [this.defaultTarget, ...this.targets].filter(Boolean);
    allTargets.forEach(target => {
        target.addEventListener('mouseenter', () => this.onTargetEnter());
        target.addEventListener('mouseleave', () => this.onTargetLeave());
    });
  }

  onTriggerEnter(e) {
    clearTimeout(this.timer);
    const trigger = e.currentTarget;
    const index = parseInt(trigger.dataset.index, 10);

    this.activate(index);
  }

  onTriggerLeave(e) {
    this.timer = setTimeout(() => {
        this.reset();
    }, 600);
  }

  onTargetEnter() {
    clearTimeout(this.timer);
  }

  onTargetLeave() {
    this.timer = setTimeout(() => {
        this.reset();
    }, 200);
  }

  activate(index) {
    // Deactivate all triggers
    this.triggers.forEach(t => t.parentElement.classList.remove('is-active'));
    // Note: The structure is <li><a>...</a></li>. 
    // Usually the design highlights the <li> or the <a>?
    // User request: "left-side menu item should remain active".
    // I'll add class to the link, and maybe parent.
    this.triggers.forEach(t => t.classList.remove('is-active'));

    // Hide default
    if (this.defaultTarget) this.defaultTarget.classList.remove('is-active');

    // Hide all targets
    this.targets.forEach(t => t.classList.remove('is-active'));

    // Activate specific
    if (this.triggers[index]) {
        this.triggers[index].classList.add('is-active');
        this.triggers[index].parentElement.classList.add('is-active'); // Just in case styling uses parent
    }
    if (this.targets[index]) this.targets[index].classList.add('is-active');
  }

  reset() {
    this.triggers.forEach(t => {
        t.classList.remove('is-active');
        t.parentElement.classList.remove('is-active');
    });
    this.targets.forEach(t => t.classList.remove('is-active'));
    
    // Show default
    if (this.defaultTarget) this.defaultTarget.classList.add('is-active');
  }
}

document.querySelectorAll('.mega-menu-block').forEach(el => new MegaMenuTabs(el));
